import { fetcher } from '@commenda/utils';
import { CreateCalComBookingPayload } from '../cal-com';

export async function createCalComMeetingBooking(
  data: CreateCalComBookingPayload
) {
  const res = await fetcher('meeting/booking', {
    method: 'POST',
    body: data,
  });

  return res;
}
